'use client';

import { Skeleton } from '@mui/material';
import { HousingCardSkeleton } from '@/components';
import { Wrapper, Head } from '@/features/pages/home';
import {
  Container,
  ControlsBox,
  SkeletonGrid,
  StyledButton,
} from '@/features/pages/home/components/Featured/styles';
import { BrokerCompanyCardsContainer } from './styled';

export const BrokerCompanyCardsSkeleton = () => (
  <Wrapper $bgColor="beige-parch">
    <BrokerCompanyCardsContainer>
      <Head>
        <Skeleton variant="text" width={320} height={40} />
      </Head>
      <Container>
        <ControlsBox>
          <StyledButton variant="outlined" disabled aria-label="Previous slide">
            <Skeleton variant="circular" width={16} height={16} />
          </StyledButton>
          <StyledButton variant="outlined" disabled aria-label="Next slide">
            <Skeleton variant="circular" width={16} height={16} />
          </StyledButton>
        </ControlsBox>
        <SkeletonGrid>
          {Array.from({ length: 3 }).map((_, i) => (
            <HousingCardSkeleton key={i} />
          ))}
        </SkeletonGrid>
      </Container>
    </BrokerCompanyCardsContainer>
  </Wrapper>
);
